import { Container, Row, Col } from 'react-bootstrap'

function ConfusingFrustrating () {
	
return (
<div>
	<div className="section__davidColby text-white bg-orange">
		<Container className="container">
			<Row className="flex-column-reverse flex-lg-row">
				<Col lg={5} md={12}>
				<div className="text-center">
					<img className="section__davidColby--img img-fluid" src="../images/tvc/img-dr-david-colby01.png" alt="David" /><br />
					<p className="mt-2"><strong>Dr. David Colby</strong></p>
				</div>
				</Col>
				<Col lg={7} md={12}>
				<div className="float-right section__davidColby--desc">
					<h2><strong>So how do you separate <br />the good from the not so good?</strong></h2>
					<p className="mt-3 mb-4"><strong>The key is to know the right questions to ask.</strong></p>
					<p className="">Discover what <strong>Dr. David Colby</strong> has to say about what to look for in a supplement. He has a doctorate in pharmacy and PHD in chemistry.
						<br /><br />
						He teaches classes on dietary supplements at the university level, where the FDA has funded over 40 years of analysis to create a library of the baseline qualities for thousands of samples of raw ingredients. Dr. Colby himself has authored over 25 scientific peer-reviewed papers. So he knows a lot about what goes into making a high quality food supplement.
					</p>
				</div>
				</Col>
			</Row>
		</Container>
	</div>
	<style jsx>{`
		.section__davidColby{
			padding: 80px 15px 50px;
		}
		.section__davidColby--desc h2{
			font-size: 2.2rem;
			line-height:1.7;
		}
		.section__davidColby--desc p:nth-child(1){
			font-size: 1.9rem;
		}
			@media(max-width: 991px){
				.container{
					max-width: 100%!important;
				}
				.section__davidColby--desc h2{
					line-height:1.3;
				}
			}
		`}
	</style>
</div>
);
}
export default ConfusingFrustrating;